// Prepend a small inline colour swatch at the START of every line that carries
// a colour, in already Prism-highlighted HTML. One swatch per line, sitting in
// front of the code like a gutter chip.
//
// Two colour formats are recognised, so this works across the whole site:
//   - a 6-digit hex (#RRGGBB) - CSS, ini/ghostty, slack configs, etc.
//   - a CorelDRAW .xml `tints="r,g,b"` triple of 0..1 RGB floats - palette files.
// The hex only ever appears in token text (never inside an attribute) and the
// tints triple is unique to the CorelDRAW palette, so neither ever false-matches.

function swatchSpan( hex: string ): string {
  return '<span class="cp-swatch-inline" style="background-color:' + hex + '"></span>';
}

function unitRgbToHex( r: string, g: string, b: string ): string {
  const to = ( v: string ) => {
    const n = Math.max( 0, Math.min( 255, Math.round( parseFloat( v ) * 255 ) ) );
    return n.toString( 16 ).padStart( 2, '0' );
  };
  return '#' + to( r ) + to( g ) + to( b );
}

export function addColorSwatches( html: string ): string {
  const unitTriple = /([01](?:\.\d+)?),\s*([01](?:\.\d+)?),\s*([01](?:\.\d+)?)/;
  return html
    .split( '\n' )
    .map( ( line ) => {
      const hex = line.match( /#([0-9a-fA-F]{6})\b/ );
      if ( hex ) {
        return swatchSpan( '#' + hex[ 1 ] ) + line;
      }
      // CorelDRAW .xml: <color ... tints="r,g,b" .../> with 0..1 RGB floats.
      if ( /tints/.test( line ) ) {
        const t = line.match( unitTriple );
        if ( t ) {
          return swatchSpan( unitRgbToHex( t[ 1 ], t[ 2 ], t[ 3 ] ) ) + line;
        }
      }
      return line;
    } )
    .join( '\n' );
}
